module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/mockup@1x-635117b978e6a87ca4a01addc678f73a.png";